export const language: any = {
    LabelLogin: "Connexion",
    LabelForgotPw: "Trouver le mot de passe",
    LabelSignUp: "Rejoindre le membre",
    LabelRememberMe: "Rester connecté",
    Or: "ou",
    Email: "E-mail",
    Password: "Mot de passe",
    LangKo: "Coréen",
    LangEn: "Anglais",
    LangVi: "Vietnamien",
    LabelCondition: "Accepter les termes et conditions",
    FullAgreement: "Entièrement d'accord",
    Next: "Suivant",
    PrivacyPolicy: `Politique de confidentialité <span class="text-[#ff6741]">(obligatoire)</span>`,
    TermOfUse: `Conditions d'utilisation <label class="text-[#ff6741]">(obligatoire)</label>`,
    VerifyPassword: "Vérifier le mot de passe",
    PlaceHolderPassword: "Entrez au moins 8 lettres + chiffres + caractères spéciaux",
    DuplicateCheck: "Vérification des doublons",
    LabelIdEmail: "ID (e-mail)",
    GN_02_MSG_01: "Votre version de l'application est obsolète. Veuillez mettre à jour pour continuer.",
    AU_02_MSG_02: "Cet e-mail est déjà enregistré, veuillez en utiliser un autre.",
    AU_02_MSG_03: "L'e-mail est disponible.",
    AU_02_MSG_01: "Veuillez entrer un format d'e-mail valide.",
    AU_01_MSG_01: "ID ou mot de passe incorrect. Veuillez réessayer.",
    AU_02_MSG_04: "Veuillez vérifier l'e-mail disponible.",
    AU_02_MSG_05: "Veuillez entrer un mot de passe d'au moins 8 caractères, comprenant des lettres, des chiffres et des caractères spéciaux.",
    AU_02_MSG_06: "La confirmation du mot de passe ne correspond pas.",
    AU_03_MSG_01: "Veuillez entrer un format d'e-mail valide.",
    AU_03_MSG_02: "Cet e-mail n'est pas enregistré dans le système.",
    AU_03_MSG_04: "※ Un code de vérification a été envoyé à l'e-mail enregistré.",
    LabelRegisterComplete: "L'inscription est terminée !",
    LabelLoginToUseService: "Connectez-vous et utilisez le service.",
    LabelDontRememberPassword: "Mot de passe oublié ?",
    LabelYouCanFindEmail: "Vous pouvez le retrouver via la vérification par e-mail.",
    LabelPasswordTemporarySendToEmail: "※ Un mot de passe temporaire sera envoyé à l'adresse e-mail enregistrée.",
    SendVerifyNumber: "Envoyer le code de vérification",
    LabelCheckYourEmailForTemporaryPassword: "Veuillez vérifier votre e-mail pour le mot de passe temporaire.",
    PlaceHolderTemporaryPassword: "Entrez le mot de passe temporaire",
    LabelTemporaryPassword: "Mot de passe temporaire",
    LabelDidntReceiveYourPassword: "Vous n'avez pas reçu votre mot de passe ?",
    LabelYouCanResendItAfter: "Vous pourrez le renvoyer après",
    LabelYouCanResendAgain: "Vous pouvez le renvoyer.",
    Confirm: "Vérifier",
    Resend: "Renvoyer",
    LabelResetPassword: "Réinitialiser le mot de passe",
    NewPassword: "Nouveau mot de passe",
    ConfirmNewPassword: "Vérifier le mot de passe",
    PlaceHolderConfirmPassword: "Confirmer le mot de passe",
    CurrentPassword: "Mot de passe actuel",
    LanguageSetting: "Paramètre de langue",
    LeaveMembership: "Annuler l'abonnement",
    LabelConfirmPasswordToLeaveMemberShip: "Veuillez vérifier votre mot de passe pour annuler votre abonnement.",
    LabelConfirmPasswordMeansYouAgreeAllContent: "Confirmer votre mot de passe signifie que vous avez lu et accepté toutes les conditions.",
    LabelCancelMembership: "Annuler l'abonnement",
    LabelBeforeLeaveYouCheckedContent: "Avant de vous désinscrire, veuillez lire et accepter les instructions ci-dessous.",
    LabelAfterLeaveAllInfoWillRemove: "Après la désinscription, toutes vos informations et historiques seront supprimés et ne pourront pas être récupérés.",
    LabelIHaveReadAndAgreeContent: "J'ai lu et j'accepte toutes les instructions.",
    ToUnsubscribe: "Se désinscrire",
    LabelWouldYouWantLogout: "Voulez-vous vous déconnecter ?",
    ChangePassword: "Changer le mot de passe",
    Menu: "Menu",
    MenuLanguageSettings: "Paramètres de langue",
    MenuPrivacyPolicy: "Politique de confidentialité",
    MenuLogout: "Déconnexion",
    MenuLeaveMembership: "Désinscription",
    LabelAreYouSureLeaveMembership: "Êtes-vous sûr de vouloir vous désinscrire ?",
    LabelIfLeaveMembershipAllInfoWillRemove: "Si vous vous désinscrivez, toutes vos informations seront supprimées et ne pourront pas être récupérées.",
    LabelPrivacyPolicy: "Politique de confidentialité",
    LabelTermOfUse: "Conditions d'utilisation",
    MI_02_MSG_01: "Votre mot de passe actuel est incorrect.",
    LabelModalLogin: "Connectez-vous ou inscrivez-vous pour accéder à cette fonctionnalité.",
    LabelIdLogin: "Connexion avec ID",
    LabelSnsApple: "Continuer avec Apple",
    LabelSnsFacebook: "Continuer avec Facebook",
    LabelSnsGoogle: "Continuer avec Google",
    LabelItemLogin: "Connectez-vous ou inscrivez-vous pour explorer une <br/> variété de fonctionnalités avec Hey!Cooker",
    LabelSnsEmail: "Connexion par e-mail",
    LoadingLogin: "Veuillez patienter un instant.",
    MenuNotificationSettings: "Paramètres des notifications",
  };
  